enum VLProfileStrength {
  Beginner = 0,
  Intermediate = 1,
  Advanced = 2,
  Expert = 3,
}
export default VLProfileStrength;
